import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAuth,
  stashLoginRedirect,
  consumeLoginRedirect,
} from "../providers/AuthContext";
import GoogleButton from "react-google-button";

const DEFAULT_ROUTE = "/projects-list";

function LoginForm() {
  const { currentUser, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Page the user was bounced from by ProtectedRoute, if any.
  const from = location.state?.from;
  const fromPath = from ? `${from.pathname}${from.search || ""}` : null;

  useEffect(() => {
    if (currentUser) {
      // Router state survives only in-app redirects; after the SAML round
      // trip the target comes back from sessionStorage instead.
      const stashed = consumeLoginRedirect();
      navigate(fromPath || stashed || DEFAULT_ROUTE, { replace: true });
    }
  }, [currentUser, navigate, fromPath]);

  const handleLogin = () => {
    stashLoginRedirect(fromPath);
    login();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <title>va-tracer</title>
      <div className="text-center mb-6">
        <h1 className="text-4xl font-bold">Vandal Library</h1>
      </div>
      <div className="max-w-sm w-full p-10 bg-white shadow-md rounded-lg flex flex-col justify-center">
        <div className="flex flex-row justify-center">
          <h2 className="text-2xl font-bold mb-4">Login</h2>
        </div>
        <div className="flex flex-row justify-center">
          <GoogleButton onClick={handleLogin}></GoogleButton>
        </div>
        <p className="text-center text-sm text-gray-500 mt-4">
          Access is granted by IT. If you can sign in with Google but still can’t
          get in, contact IT to request Tracer access.
        </p>
      </div>
    </div>
  );
}

export default LoginForm;
